import { render } from "./settingsChallenge.html?vue&type=template&id=c633ae18"
import script from "./SettingsChallenge.vue?vue&type=script&lang=ts"
export * from "./SettingsChallenge.vue?vue&type=script&lang=ts"
script.render = render

export default script